import http from './http';

// Get all job roles (optionally filter by active status)
export const getJobRoles = (active) =>
  http.get('/api/careers/roles', {
    params: active !== undefined ? { active } : {},
  });

// Get job role by ID
export const getJobRoleById = (id) => http.get(`/api/careers/roles/${id}`);

// Create a new job role
export const createJobRole = (data) => http.post('/api/careers/roles', data);

// Update existing job role
export const updateJobRole = (id, data) => http.put(`/api/careers/roles/${id}`, data);

// Delete job role
export const deleteJobRole = (id) => http.delete(`/api/careers/roles/${id}`);

// Submit a job application (with file upload)
export const submitApplication = (formData) =>
  http.post('/api/careers/applications', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
